import { useMemo } from 'react';

import column from '@Components/Grid/utils/column';

import LogFormatter, { DateFormatter } from './LogFormatter';

export default function useColumns() {
  return useMemo(() => [
    column.accessor('date', {
      header: 'Date',
      cell: info => <DateFormatter info={info} />,
      enableSorting: false,
    }),
    column.accessor('description', {
      header: 'Description',
      cell: info => <LogFormatter info={info} />,
      enableSorting: false,
      className: 'min-w-[55vw]',
    }),
  ], [])
}
